<template>
  <div class='Home'>
    <div class="leftMenu">
      <div class="logo">
        <template v-if="$isWuHan">
          <img src="@/assets/card-logo.png" style="width: 75px;height: 75px;"/>
        </template>
        <template v-else>
          <img src="@/assets/card-logo.png"  style="width: 75px;height: 75px;"/>
        </template>
      </div>
      <Menu></Menu>
    </div>
    <div class="right">
      <Header class="rightHeader"></Header>
      <div class="container">
        <div class="page">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Menu from '@/components/Menu'
import Header from '@/components/Header'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Header,
    Menu
  },
  data () {
    // 这里存放数据
    return {
      LeftCollapseMenu: {
        // icon: ['el-icon-s-order', 'el-icon-menu', 'el-icon-document', 'el-icon-tickets', 'el-icon-setting'],
        // route: ['/cybercash', '/serviceDesk', '/dataFile', '/task', '/setting']
        icon: [],
        route: []
      },
      LeftCacheMenu: {
        cybercash: [],
        serviceDesk: [],
        dataFile: [],
        task: [],
        setting: []
      },
      menuIndex: '/cybercash',
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    changIndex (v) {
      this.menuIndex = v
    }
  },
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.Home {
  width: 100%;
  height: 100%;
  min-width: 1280px;
  display: flex;

  .leftMenu {
    position: fixed;
    z-index: 9999;
    width: 200px;
    height: 100%;
    background-color: #fff;

    .logo {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px auto 20px;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .right {
    flex: 1;
    display: flex;
    margin-left: 200px;
    flex-direction: column;
    overflow-x: hidden;

    .rightHeader {
      position: fixed;
      top: 0;
    }

    .container {
      display: flex;
      flex: 1;
      margin-top: 60px;
      .page {
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: #f0f2f5;
        overflow: hidden;

        &> :last-child {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
</style>
